// Renders the small Markdown subset toolkit content uses: "## " headings,
// "- " bullets, "1. " numbered lines, **bold** and paragraphs. Text only -
// never raw HTML, so content can't inject markup.
const inline = (text, key) => text.split(/(\*\*[^*]+\*\*)/g).map((part, i) =>
  part.startsWith("**") && part.endsWith("**") ? <strong key={`${key}-${i}`}>{part.slice(2, -2)}</strong> : part);

export default function SimpleMarkdown({ text, className = "" }) {
  const blocks = [];
  let list = null;
  (text || "").split("\n").forEach((raw, i) => {
    const line = raw.trimEnd();
    const bullet = line.match(/^\s*[-*] (.*)/);
    const num = line.match(/^\s*\d+\. (.*)/);
    if (bullet || num) {
      const type = bullet ? "ul" : "ol";
      if (!list || list.type !== type) { list = { type, items: [] }; blocks.push(list); }
      list.items.push((bullet || num)[1]);
      return;
    }
    list = null;
    if (!line.trim()) return;
    const h = line.match(/^#{1,3} (.*)/);
    blocks.push(h ? { type: "h", text: h[1] } : { type: "p", text: line });
  });
  return (
    <div className={`space-y-2 text-sm text-secondary-700 ${className}`}>
      {blocks.map((b, i) => {
        if (b.type === "h") return <h4 key={i} className="pt-1 text-sm font-bold text-secondary-900">{b.text}</h4>;
        if (b.type === "p") return <p key={i} className="leading-relaxed">{inline(b.text, i)}</p>;
        const Tag = b.type;
        return (
          <Tag key={i} className={`${b.type === "ul" ? "list-disc" : "list-decimal"} pl-5 space-y-1`}>
            {b.items.map((t, j) => <li key={j}>{inline(t, `${i}-${j}`)}</li>)}
          </Tag>
        );
      })}
    </div>
  );
}
